export const KanbanStatusLabel = {
  0: 'por hacer',
  1: 'en proceso',
  2: 'hecho'
}